import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i1454659948__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Pin / Ort", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i1454659948__cls-1{fill:none}.i1454659948__cls-2{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M96.01 51.99c-11.03 0-20 8.97-20 20s8.97 20 20 20 20-8.97 20-20-8.97-20-20-20",
      class: "i1454659948__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M96.01 16C65.12 16 40 41.13 40 72.01c0 22.9 18.7 65.75 54.44 103.34.54.57 1.21.66 1.51.64.32 0 .93-.1 1.43-.65 26.86-29.85 54.64-76.67 54.64-103.33 0-30.89-25.13-56.01-56.01-56.01m0 84c-15.44 0-28-12.56-28-28s12.56-28 28-28 28 12.56 28 28-12.56 28-28 28",
      class: "i1454659948__cls-1"
    }, null, -1)),
    _cache[4] || (_cache[4] = _createElementVNode("path", {
      d: "M96.01 8C60.71 8 32 36.72 32 72.01c0 32.36 28.5 79.25 56.64 108.86 1.9 1.99 4.54 3.13 7.28 3.13h.14a10 10 0 0 0 7.27-3.3c13.57-15.08 27.31-34.42 37.72-53.05 8.66-15.5 18.97-37.74 18.97-55.63 0-35.3-28.72-64.01-64.01-64.01Zm1.37 167.35c-.5.56-1.11.65-1.43.65-.3.02-.97-.07-1.51-.64C58.7 137.77 40 94.92 40 72.02c0-30.89 25.13-56.01 56.01-56.01s56.01 25.13 56.01 56.01c0 26.67-27.78 73.48-54.64 103.33",
      class: "i1454659948__cls-2"
    }, null, -1)),
    _cache[5] || (_cache[5] = _createElementVNode("path", {
      d: "M96.01 43.99c-15.44 0-28 12.56-28 28s12.56 28 28 28 28-12.56 28-28-12.56-28-28-28m0 48.01c-11.03 0-20-8.97-20-20s8.97-20 20-20 20 8.97 20 20-8.97 20-20 20",
      class: "i1454659948__cls-2"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "pin"}) } }